import { apiRequest } from '../api/client';
import { API_ENDPOINTS, withParams } from '../config/apis';

export type QnaState = 'WAITING' | 'COMPLETED';
export type QnaType = 'ACCOUNT' | 'RECORD' | 'ETC';

export type QnaPost = {
  id: number;
  depth: number;
  writer: string;
  title: string;
  content: string | null;
  type: QnaType;
  state: QnaState;
  secret: boolean;
  createdAt: string;
};

export type QnaListItem = QnaPost & {
  answerWriterEmail?: string;
};

export type QnaAnswer = {
  id: number;
  qnaId: number;
  writerEmail: string;
  title: string;
  content: string | null;
  answeredAt: string;
};

export type QnaDetail = {
  id: number;
  writer: string;
  title: string;
  content: string;
  type: QnaType;
  state: QnaState;
  secret: boolean;
  createdAt: string;
  answer: QnaAnswer | null;
};

type QnaListResponse = {
  qnas: QnaPost[];
};

type QnaAnswerRequest = {
  writerEmail: string;
  answer: string;
};

type QnaDeleteRequest = {
  qnaIds: number[];
};

function toQnaListItems(qnas: QnaPost[]) {
  const questions: QnaListItem[] = [];

  qnas.forEach((qna) => {
    if (qna.depth === 0) {
      questions.push(qna);
      return;
    }

    const lastQuestion = questions.at(-1);

    if (lastQuestion) {
      lastQuestion.answerWriterEmail = qna.writer;
    }
  });

  return questions;
}

export const qnaService = {
  list: (keyword = '') =>
    apiRequest<QnaListResponse>(API_ENDPOINTS.qnaList, {
      query: { keyword: keyword.trim() || undefined },
    }).then((response) => toQnaListItems(response.qnas)),

  detail: (qnaId: number) =>
    apiRequest<QnaDetail>(withParams(API_ENDPOINTS.qnaDetail, { qnaId })),

  createAnswer: (qnaId: number, body: QnaAnswerRequest) =>
    apiRequest<QnaAnswer, QnaAnswerRequest>(withParams(API_ENDPOINTS.qnaAnswerCreate, { qnaId }), { body }),

  updateAnswer: (qnaId: number, body: QnaAnswerRequest) =>
    apiRequest<QnaAnswer, QnaAnswerRequest>(withParams(API_ENDPOINTS.qnaAnswerUpdate, { qnaId }), { body }),

  delete: (qnaId: number) =>
    apiRequest<void, QnaDeleteRequest>(API_ENDPOINTS.qnaDelete, { body: { qnaIds: [qnaId] } }),
};
